import { useDarkMode } from './mediaQueries';

const CHECKER_LIGHT =
  'iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAH0lEQVQI12O8w8DAIMfAwMDEAAWYDMZfDAwMj/CrAQCEzgLlcKr6lwAAAABJRU5ErkJggg==';

const CHECKER_DARK =
  'iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAHklEQVQI12M0YmBgMGJgYGBigAJMBosRAwPDOfxqAD2MAXbBZjJFAAAAAElFTkSuQmCC';

export const useTransparentPatternStyles = ({
  colors,
}: {
  colors: string[];
}) => {
  const { isDarkMode } = useDarkMode();

  const isTransparent = colors.length === 1 && colors[0] === 'transparent';

  if (isTransparent) {
    const checker = isDarkMode ? CHECKER_DARK : CHECKER_LIGHT;
    return {
      styles: { backgroundImage: `url(data:image/png;base64,${checker})` },
    };
  }

  const colorStops = colors
    .map((color, index) => {
      const startValue = (100 / colors.length) * index;
      const stopValue = (100 / colors.length) * (index + 1);

      return `${color} ${startValue}%, ${color} ${stopValue}%`;
    })
    .join(',');

  return {
    styles: { backgroundImage: `linear-gradient(45deg, ${colorStops})` },
  };
};
